"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _reactFeather = require("react-feather");

var _Box = _interopRequireDefault(require("../../Layout/Box"));

var _Elements = require("../../Elements");

var _Modules = require("../../Modules");

var _Modal = require("./Modal.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Modal = function Modal(_a) {
  var title = _a.title,
      children = _a.children,
      _b = _a.closeIcon,
      closeIcon = _b === void 0 ? _react.default.createElement(_reactFeather.XCircle, null) : _b,
      closeTitle = _a.closeTitle,
      className = _a.className,
      _c = _a.largeTitle,
      largeTitle = _c === void 0 ? false : _c,
      props = (0, _tslib.__rest)(_a, ["title", "children", "closeIcon", "closeTitle", "className", "largeTitle"]);
  return _react.default.createElement(_Modules.Layer, (0, _tslib.__assign)({}, props), _react.default.createElement(_Modal.ModalBox, {
    "aria-labelledby": title,
    "aria-modal": props.isOpen,
    className: className,
    role: "dialog"
  }, _react.default.createElement(_focusTrapReact.default, {
    active: !!closeIcon && props.isOpen
  }, _react.default.createElement(_Box.default, null, _react.default.createElement(_Modal.Header, null, !largeTitle ? _react.default.createElement(_Modal.ModalTitle, null, title) : _react.default.createElement("div", null), closeIcon && _react.default.createElement(_Elements.Anchor, {
    "aria-label": "Close",
    as: "button",
    color: "#949494",
    onClick: props.onClose,
    title: closeTitle
  }, closeIcon)), largeTitle && title && _react.default.createElement(_Modal.LargeTitle, {
    mx: "auto",
    fontSize: 6
  }, title), _react.default.createElement(_Modal.Body, null, children)))));
};

var _default = Modal;
exports.default = _default;